function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import ContentHandler from '../common/classes/ContentHandler';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import initToggleMenu from '../common/functions/initToggleMenu';
var $callback = function $callback(element) {
  var button = document.querySelector('button.js-content-loader');
  if (button && element !== '') {
    var srcContent = button.dataset.srcContent;
    var _srcContent$split = srcContent.split('&filter='),
      _srcContent$split2 = _slicedToArray(_srcContent$split, 2),
      url = _srcContent$split2[0],
      univers = _srcContent$split2[1];
    var encodeUrl = "".concat(url, "&filter=").concat(element);
    button.dataset.srcContent = encodeUrl;
  }
};
var MagazineRubrique = /*#__PURE__*/function (_lm$Composant) {
  /**
   * @constructor
   * @param {String} id
   */
  function MagazineRubrique(id) {
    var _this;
    _classCallCheck(this, MagazineRubrique);
    _this = _callSuper(this, MagazineRubrique, [id]);
    var filterSeparator = ";";

    // Init pagination display
    var paginationParam = new URL(document.location).searchParams.get("p");
    var filterParam = new URL(document.location).searchParams.get("filter");
    scrollMagazineRubriqueIntoView();
    initBrowserUrl();
    initTags();

    // Filter Layer
    var filterLayer = document.querySelector(".js-filters-layer");
    var openFilterLayerButton = document.getElementById('js-open-filter-layer');
    var closeFilterLayerButton = filterLayer.querySelector(".js-close-layer");
    if (openFilterLayerButton) {
      openFilterLayerButton.addEventListener('click', openLayer);
      openFilterLayerButton.addEventListener('keydown', function (event) {
        if (event.code === "Enter" || event.code === "Space") {
          event.preventDefault();
          openLayer();
        }
      });
    }
    if (closeFilterLayerButton) {
      closeFilterLayerButton.addEventListener('click', function (event) {
        event.preventDefault();
        closeLayer();
      });
    }
    var submitFilterButton = filterLayer.querySelector(".js-submit-filter");
    submitFilterButton.addEventListener('click', onSubmitFilterForm);
    var eraseAllFilterButton = filterLayer.querySelector(".js-erase-all-filter");
    eraseAllFilterButton.addEventListener('click', onClickEraseAllFilter);
    initToggleMenu();
    new ContentHandler('Rubriques');
    function scrollMagazineRubriqueIntoView() {
      if (paginationParam) {
        document.querySelector('.js-content-loader-container').scrollIntoView();
      }
    }
    function initBrowserUrl() {
      var url = new URL(document.location);
      if (paginationParam) {
        if (filterParam) {
          window.history.replaceState("", "", "?p=" + currentPage + "&filter=" + url.search.slice(url.search.indexOf("filter=") + "filter=".length));
        } else {
          window.history.replaceState("", "", "?p=" + currentPage);
        }
      }
    }
    function initFilterForm() {
      var urlParams = new URLSearchParams(document.location.search);
      if (urlParams.size > 0 && urlParams.has("filter")) {
        var filters = decodeFilterParam(urlParams.get("filter").split(filterSeparator));
        filters.forEach(function (filter) {
          return checkFilter(filter.split(":"));
        });
      }
    }
    function initTags() {
      if (filterParam) {
        var categories = decodeFilterParam(filterParam.split(filterSeparator));
        var filters = [];
        categories.forEach(function (categorie) {
          filters.push(categorie.split(":")[1]);
        });
        createTags(filters);
      }
    }
    function decodeFilterParam(filters) {
      filters.forEach(function (filter, index) {
        if (!filter.includes(":")) {
          filters[index - 1] += filterSeparator + filter;
          filters[index] = null;
        }
      });
      return filters.filter(function (filter) {
        return filter != null;
      });
    }
    function checkFilter(filter) {
      var id = filter[0];
      var name = filter[1];
      var inputs = filterLayer.querySelectorAll("input");
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].id.startsWith(id) && inputs[i].name === name) {
          inputs[i].checked = true;
        }
      }
    }
    function openLayer() {
      initFilterForm();
      // We need to get layerOverlay here because it's not created in the DOM when
      // the script is executed but it is when the user click on the button
      var layerOverlay = document.getElementById("js-filter-layer-overlay");
      layerOverlay.classList.add("is-visible");
      filterLayer.querySelector(".mc-layer__dialog").classList.add('is-open');
      filterLayer.querySelector(".mc-accordion").classList.add("is-open");
      setTimeout(function () {
        filterLayer.querySelector("button.mc-layer__close").focus();
      }, 400);
      eraseAllFilterButton.addEventListener('keydown', function (event) {
        if (event.code === "Tab") {
          event.preventDefault();
          filterLayer.querySelector("button.mc-layer__close").focus();
        }
      });

      // We need to add event on overlay to close layer
      layerOverlay.addEventListener('click', closeLayer);
    }
    function closeLayer() {
      // Same as the openFilterLayerButton up
      var layerOverlay = document.getElementById("js-filter-layer-overlay");
      layerOverlay.classList.remove("is-visible");
      filterLayer.querySelector(".mc-layer__dialog").classList.remove('is-open');
      var accordions = filterLayer.querySelectorAll(".mc-accordion");
      accordions.forEach(function (accordion) {
        accordion.classList.remove("is-open");
      });
      openFilterLayerButton.focus();
    }
    function onSubmitFilterForm() {
      closeLayer();
      var filterUrlValue = "";
      var filters = [];
      var inputs = filterLayer.querySelectorAll(".mc-checkbox__input:checked");
      inputs.forEach(function (element) {
        return filterUrlValue += element.dataset.filterCode + ":" + element.name + filterSeparator;
      });
      inputs.forEach(function (element) {
        return filters.push(element.name);
      });
      filterUrlValue = filterUrlValue.substring(0, filterUrlValue.length - 1); //remove last ,
      filterUrlValue = encodeURIComponent(filterUrlValue);
      updateTags(filters);
      updateUrlParams(filterUrlValue);
      reloadRubrique(filterUrlValue);
    }
    function removeAllCheckedFilters() {
      var inputs = filterLayer.querySelectorAll(".mc-checkbox__input:checked");
      inputs.forEach(function (element) {
        return element.checked = false;
      });
    }
    function updateUrlParams(filterValue) {
      var paginationParam = new URL(document.location).searchParams.get("p");
      if (filterValue) {
        if (paginationParam) {
          window.history.replaceState("", "", "?p=" + paginationParam + "&filter=" + filterValue);
        } else {
          window.history.replaceState("", "", "?filter=" + filterValue);
        }
      } else {
        window.history.replaceState("", "", window.location.pathname);
      }
    }
    function createTags(filters) {
      var filterTagContainer = document.getElementById("rubrique-filter-tags");
      var fragment = document.createDocumentFragment();
      if (filters.length > 0) {
        filters.forEach(function (filter) {
          var tag = buildTag(filter);
          fragment.append(tag);
        });
        filterTagContainer.append(fragment);
        var resetAllFiltersLink = buildResetAllFiltersLink();
        filterTagContainer.append(resetAllFiltersLink);
      }
    }
    function buildTag(filter) {
      var tag = document.createElement("span");
      var spanLabel = tag.cloneNode();
      spanLabel.className = "mc-tag-removable__label";
      spanLabel.textContent = filter;
      var spanText = spanLabel.cloneNode();
      spanText.className = "mc-tag-removable__remove-text";
      var buttonRemove = document.createElement("button");
      buttonRemove.className = "mc-tag-removable__remove";
      buttonRemove.ariaLabel = deleteLabel;
      buttonRemove.appendChild(spanText);
      tag.className = "mc-tag-removable js-rubrique-filters-remove-btn";
      tag.dataset.paramName = filter;
      tag.append(spanLabel, buttonRemove);
      tag.addEventListener("click", onClickTagRemovable);
      return tag;
    }
    function buildResetAllFiltersLink() {
      var resetAllFiltersLink = document.createElement("a");
      resetAllFiltersLink.id = "js-reset-filters-btn";
      resetAllFiltersLink.className = "js-reset-filters-btn";
      resetAllFiltersLink.textContent = resetAllFiltersLinkLabel;
      resetAllFiltersLink.addEventListener("click", onClickResetFiltersBtn);
      return resetAllFiltersLink;
    }
    function onClickTagRemovable(event, resetLink) {
      var filterNameToDelete = event.target.parentElement.dataset.paramName;
      var filterUrlValue = "";
      var inputs = filterLayer.querySelectorAll(".mc-checkbox__input:checked");
      inputs.forEach(function (element) {
        if (element.name !== filterNameToDelete) {
          filterUrlValue += element.dataset.filterCode + ":" + element.name + filterSeparator;
        } else {
          element.checked = false;
        }
      });
      filterUrlValue = filterUrlValue.substring(0, filterUrlValue.length - 1); //remove last ,
      filterUrlValue = encodeURIComponent(filterUrlValue);
      updateUrlParams(filterUrlValue);
      reloadRubrique(filterUrlValue);
      if (event.target.parentElement.parentElement.childNodes.length === 2) {
        document.getElementById("js-reset-filters-btn").remove();
      }
      event.target.parentElement.remove();
    }
    function updateTags(filters) {
      var container = document.getElementById("rubrique-filter-tags");
      container.replaceChildren();
      if (filters.length > 0) {
        createTags(filters);
      }
    }
    function onClickResetFiltersBtn(event) {
      event.preventDefault();
      removeAllCheckedFilters();
      updateTags([]);
      updateUrlParams("");
      reloadRubrique("");
    }
    function onClickEraseAllFilter(event) {
      removeAllCheckedFilters();
    }
    function reloadRubrique(filterValueUrl) {
      var sectionId = document.querySelector("#rubrique-filter-form").dataset.sectionId;
      var currentPage = new URL(document.location).searchParams.get("p") || 1;
      var filterUrl = "/magazine/reload/rubrique/articles?p=" + currentPage + "&size=15&sectionId=" + sectionId;
      var url = filterValueUrl.length > 0 ? "".concat(filterUrl, "&filter=").concat(filterValueUrl) : filterUrl;
      lm.fetch({
        url: url,
        success: function success(data) {
          refreshContainer(data, filterValueUrl);
        },
        complete: lm.lazyload.observe
      });
    }
    function refreshContainer(data, filterValue) {
      document.querySelector('.js-content-loader-container').innerHTML = data;

      // use to infinity scroll
      new ContentHandler('Rubrique');
      $callback.call(this, filterValue);
    }

    // Accordion steps
    _toConsumableArray(_this.target.querySelectorAll('.js-accordion')).forEach(function (el) {
      new Accordion(el);
    });
    return _this;
  }
  _inherits(MagazineRubrique, _lm$Composant);
  return _createClass(MagazineRubrique);
}(lm.Composant);
lm.DOMReady(function () {
  new MagazineRubrique('magazinerubrique');
});